//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyIcon from './CardPropertyIcon.vue'
import ItemsSearchField from '../Field/ItemsSearchField.vue'
import { createFieldConfig, Store } from '../QSelectUtils.js'
import { cardPropertyMixin } from './CardPropertyMixin.js'
import { cardPropertyConfigurableMixin } from './CardPropertyConfigurableMixin.js'

// TODO учитывать listelementtype

export default {
  name: 'CardPropertyListValue',
  components: {
    CardPropertyIcon,
    ItemsSearchField
  },
  mixins: [cardPropertyMixin, cardPropertyConfigurableMixin],
  data: function () {
    return {
      itemsSearchConfig: createFieldConfig(new Store({
        itemsFn: this.getOptions,
        fullReadable: true,
        cached: false,
        searchable: true,
        searchFiltrationBySource: false,
        searchValueMinLength: 0
      }))
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.object[this.tabProp.key]
      },
      set (newValue) {
        this.object[this.tabProp.key] = newValue
      }
    },
    value: {
      get () {
        let value = this.inputValue
        if (this.tabProp.componentProps && this.tabProp.componentProps.arrayModel && !this.tabProp.ismultiselect) {
          if (value && value.length) {
            value = value[0]
          }
        }
        return value
      },
      set (newValue) {
        if (this.componentProps.arrayModel && !this.tabProp.ismultiselect) {
          this.inputValue = newValue ? [newValue] : []
        } else {
          this.inputValue = newValue
        }
      }
    },
    selectedItemsObjects: {
      get () {
        const value = this.inputValue
        if (value) {
          return this.tabProp.listvalues.filter(el => value.includes(el.value))
        }
        return []
      },
      set (newValue) {
        // this.value = newValue.map(item => item.value) // TODO - Почему было this.value если берется из this.inputValue ?
        this.inputValue = newValue.map(item => item.value)
      }
    },
    copyAvailable: function () {
      const config = this.tabProp || {}
      return config.componentProps && config.componentProps.copy
    }
  },
  // watch: {
  //   inputValue: {
  //     handler: function (value) {
  //       if (value === null || value && value.length === 0) {
  //         // console.log('watch inputValue:', value)
  //         this.value = value // TODO - Зачем это присвоение, если this.value и так вычисляется из this.inputValue ?
  //       }
  //     }
  //   }
  // },
  methods: {
    onInput: function (value) {
      if (this.tabProp.onPropertyInput instanceof Function) {
        this.tabProp.onPropertyInput(value, this.object)
      }
    },
    onCopy: function (e) {
      const data = [new window.ClipboardItem({ 'text/plain': new Blob([this.tabProp.listvalues.filter(el => el.value === this.object[this.tabProp.key])[0].name], { type: 'text/plain' }) })]
      navigator.clipboard.write(data)
    },
    getOptions: function () {
      return this.tabProp.listvalues.map(value => {
        value.id = value.value
        return value
      })
    }
  }
}
